export default __webpack_public_path__ + "static/media/bg-login.9a903f22.png";